var _polygon, _polygon2, _polygon3, _polygon4, _polygon5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisinvoLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "full",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    padding: 0,
    margin: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "128,17.5 231.5,67.5 128,125 24.5,67.5",
    strokeWidth: 0.2,
    stroke: "hsl(200, 73%, 82%)",
    fill: "hsl(207, 53%, 54%)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "24.5,67.5 128,125 128,248.5 24.5,182.5",
    strokeWidth: 0.2,
    stroke: "hsl(200, 73%, 82%)",
    fill: "hsl(216, 48%, 29%)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "128,125 231.5,67.5 231.5,182.5 128,248.5",
    strokeWidth: 0.2,
    stroke: "hsl(200, 73%, 82%)",
    fill: "hsl(203, 65%, 42%)"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "77.5,70.75 99.75,70.75 125.25,162.5 125.25,190 113.25,190",
    strokeWidth: 0.2,
    stroke: "#ffdf9f",
    fill: "hsl(42, 100%, 50%)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "178.5,70.75 156.25,70.75 130.5,162.5 130.5,190 142.5,190",
    strokeWidth: 0.2,
    stroke: "#ffdf9f",
    fill: "hsl(42, 100%, 50%)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisinvoLogo);
export default __webpack_public_path__ + "static/media/visinvo_logo.5eef6b165abf6c13fa25e6913e9e20d2.svg";
export { ForwardRef as ReactComponent };